import Location from "../../../../assets/svg/location.svg?react";

export function LocationPin() {
  return <Location />;
}
